/**
 * @fileoverview > handler for the "/engagement/:app_group_id/create_spam_test" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdCreateSpamTestCacheKeys } from "./constants";
import type { PostEngagementAppGroupIdCreateSpamTestProps, EngagementCreateSpamTestResult } from "./types";

export const postEngagementCreateSpamTest = reactQueryMutationAdapter(
  engagementAppGroupIdCreateSpamTestCacheKeys,
  ({
    appGroupId,
    message,
    triggerPropertiesHash,
  }: PostEngagementAppGroupIdCreateSpamTestProps): Promise<EngagementCreateSpamTestResult> => {
    return fetch(`/engagement/${appGroupId}/create_spam_test`, "POST", {
      message,
      trigger_properties_hash: triggerPropertiesHash,
    });
  }
);
